<template>
  <v-data-table
    :headers="headers"
    :items="items"
    dense
    :search="search"
    sort-by="paymentDate"
    sort-desc
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-row>
          <v-col cols="12" sm="12" md="9" lg="9">
            <v-text-field
              flat
              dense
              outlined
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3" class="text-right">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="success" v-on="on" dark rounded @click="updateChecklist">
                  <v-icon>
                    mdi-content-save
                  </v-icon>
                </v-btn>
              </template>
              <span>Update Checklist</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-toolbar>
    </template>
    <template v-slot:item.no="{ item }">
      {{ items.map(x => x).indexOf(item) + 1 }}
    </template>
    <template v-slot:item.amount="{ item }">
      {{ formatPrice(item.amount) }}
    </template>
    <template v-slot:item.bankName="{ item }">
      {{ item.accountNumber.bankExternal ? item.accountNumber.bankExternal.name : "" }}
    </template>
    <template v-slot:item.accountNumber="{ item }">
      {{ item.accountNumber.accountNumber }}
    </template>
    <template v-slot:item.ownerName="{ item }">
      {{ item.accountNumber.ownerName }}
    </template>
    <template v-slot:item.biFast="{ item }">
      {{ item.accountNumber.different ? "Yes" : "No" }}
    </template>
    <template v-slot:item.action="{ item }">
      <v-col cols="12" class="text-center">
        <v-checkbox v-model="item.checklist"></v-checkbox>
      </v-col>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
export default {
  data: () => ({
    items: [],
    headers: [
      {
        id: 1,
        text: "No",
        align: "center",
        sortable: false,
        value: "no",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 3,
        text: "Forwarder",
        value: "vendorName",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 4,
        text: "Pay Date",
        value: "paymentDate",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 5,
        text: "Method",
        value: "methodPayment",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 5,
        text: "Amount",
        value: "amount",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 6,
        text: "Bank",
        value: "bankName",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 6,
        text: "Account Number",
        value: "accountNumber",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 6,
        text: "Owner",
        value: "ownerName",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 6,
        text: "BI Fast",
        value: "biFast",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        id: 6,
        text: "Action",
        value: "action",
        sortable: false,
        align: "center",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
    ],
    search: "",
  }),

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.commit("SET_LOADER", true);
      this.$store
        .dispatch("purchaseOtherPayment/getChecklist")
        .then(response => {
          this.items = response.data.filter(
            item => item.accountNumber && item.accountNumber.bankExternal
          );
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    async updateChecklist() {
      const filteredItems = this.items.filter(item => item.checklist);
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("purchaseOtherPayment/updateChecklist", filteredItems)
        .then(() => {
          this.$store.dispatch("toast", {
            type: "success",
            message: "Checklist updated successfully",
          });
          this.$store.commit("SET_LOADER", false);
          this.initialize();
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>

<style></style>
